<app-select-dropdown
  [options]="languageOptions"
  [value]="selectedLanguage"
  [matSymbol]="languageSymbol"
  [iconOnly]="true"
  (valueChange)="onLanguageChange($event)"
></app-select-dropdown>
